import '../src/css/App.css';
import Footer from './frontend/components/Footer';
import Header from './frontend/components/Header';
import ScrollToTop from './frontend/components/ScrollToTop';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from './frontend/pages/HomePage';
import PrivacyPolicyPage from './frontend/pages/PrivacyPolicyPage';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/*" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}
  

export default App;
